import { useEffect } from "react";
import { GestockProvider, useGestock } from "./GestockContext";
import GLayout from "./GLayout";
import GDashboard from "./pages/GDashboard";
import GSousDouane from "./pages/GSousDouane";
import GLibrePratique from "./pages/GLibrePratique";
import GCommandes from "./pages/GCommandes";
import GStations from "./pages/GStations";
import GJournal from "./pages/GJournal";
import GRapport from "./pages/GRapport";
import GParametres from "./pages/GParametres";
import { useSelector } from "react-redux";

function GestockPages() {
  const { activePage } = useGestock();
  const { isAdmin } = useSelector((state) => state.auth);

  // Save current page to localStorage for persistence
  useEffect(() => {
    localStorage.setItem("lastVisitedPage", "/dashboard");
    localStorage.setItem("gestockPage", activePage);
    // Mark that user is in Gestock
    localStorage.setItem("inGestock", "true");
  }, [activePage]);

  switch (activePage) {
    case "dashboard":
      return <GDashboard />;
    case "sous-douane":
      return <GSousDouane />;
    case "libre-pratique":
      return <GLibrePratique />;
    case "commandes":
      return <GCommandes />;
    case "stations":
      return <GStations />;
    case "journal":
      return <GJournal />;
    case "rapport":
      return <GRapport />;
    case "parametres":
      // Réservé aux admins (page mémorisée d'un autre compte → tableau de bord)
      return isAdmin ? <GParametres /> : <GDashboard />;
    default:
      return <GDashboard />;
  }
}

export default function GestockWebApp() {
  return (
    <GestockProvider>
      <GLayout>
        <GestockPages />
      </GLayout>
    </GestockProvider>
  );
}
